export const FormatDay = (date: Date) => {
  const month = date.getMonth() + 1
  const day = date.getDate()
  return `${date.getFullYear()}-${month > 9 ? month : `0${month}`}-${day > 9 ? day : `0${day}`}`
}

export const getLastDay = (now: Date, last: number) => {
  return new Date(new Date(FormatDay(now)).getTime() - (24 * 3600 * 1000 * last))
}